export default __webpack_public_path__ + "static/media/bilyana_m.079b1553.jpg";